<template>
	<div class="navigation">
		<div class="navig">
			<div class="image  iconfont" @click="toindex">&#xe617;
				<!-- <img :src="img"> -->
			</div>
			<div class="button" @click="change()">
				<div class="line1" :style="defaultstyle1"></div>
				<div class="line2" :style="defaultstyle2"></div>
			</div>
		
		</div>
		
		<div class="navbox " :class="flag ? 'animated fadeInDown':'animated fadeOutUp' "  v-if="flagTow">
			<div class="search" style="display: none;">
				<input type="text" placeholder="搜索 乐班人体工学可调背靠" />
				<div class="icon iconfont">&#xe60a;</div>
			</div>
			
			<div class="list" v-for="item in nList" @click="tonext" :data-link="item.link">{{item.title}}</div>
		</div>
		
	</div>
	



</template>

<script>
	export default {
		name: 'navigationBar',
		data() {
			return {
				//fadeInDown
				// img: this.GLOBAL.imgHost + '/images/logo.png',
				defaultstyle1: 'transform:rotate(0deg);',
				defaultstyle2: 'transform:rotate(0deg);',
				flag: false,
				flagTow: false,
				nList: [{
						title: '关于我们',
						link: 'aboutus'
					},
					{
						title: '产品介绍',
						link: 'product'
					},
					{
						title: '服务支持',
						link: 'service'
					},
					{
						title: '经营渠道',
						link: 'shop'
					}
				]
			}
		},
		methods: {
			change() {
				let that = this
				that.flagTow = true
				if (that.flag == false) {
					that.defaultstyle1 = 'animation: cuIcon-spin11 0.3s  linear;animation-fill-mode : forwards;'
					that.defaultstyle2 = 'animation: cuIcon-spin12 0.3s  linear;animation-fill-mode : forwards;'
					that.flag = true
					document.body.style.overflow = 'hidden';
					// console.log("走这");
				} else {
					that.defaultstyle1 = 'animation: cuIcon-spin13 0.3s  linear;animation-fill-mode : none;'
					that.defaultstyle2 = 'animation: cuIcon-spin14 0.3s  linear;animation-fill-mode : none;'
					that.flag = false
					document.body.style.overflow = 'auto';
					// console.log("走这1");
				}

			},
			tonext(e){
				console.log("e",e)
				console.log(" e.target.dataset.link",e.target.dataset.link)
				document.body.style.overflow = 'auto';
				let that = this;
				this.$router.push({
					path: '/' + e.target.dataset.link,
				}).catch(err => {
					that.change();
				})
			},
			toindex(){
				let that = this;
				document.body.style.overflow = 'auto';
				this.$router.push({
					path: '/index'
				}).catch(err => {

				})
			}
			
		}
	}
</script>

<style>
	@keyframes cuIcon-spin11 {
		0% {

			-webkit-transform: rotate(0deg);
			transform: rotate(0deg);
			top: 1.75rem;
		}
		
		20% {
			-webkit-transform: rotate(0deg);
			transform: rotate(0deg);
			top: 1.35rem;
		}


		100% {
			-webkit-transform: rotate(40deg);
			transform: rotate(40deg);
			top: 1.335rem;
		}
	}

	@keyframes cuIcon-spin12 {
		0% {
			-webkit-transform: rotate(0deg);
			transform: rotate(0deg);
			top: 0.625rem;
		}
		
		20% {
			-webkit-transform: rotate(0deg);
			transform: rotate(0deg);
			top: 1.335rem;
		}

		100% {
			-webkit-transform: rotate(-45deg);
			transform: rotate(-45deg);
			top: 0.875rem;
		}
	}

	@keyframes cuIcon-spin13 {
		0% {
			-webkit-transform: rotate(40deg);
			transform: rotate(40deg);
			top: 1.335rem;
		}
		
		20% {
			-webkit-transform: rotate(0deg);
			transform: rotate(0deg);
			top: 1.35rem;
		}
		
		100% {
			-webkit-transform: rotate(0deg);
			transform: rotate(0deg);
		}
	}

	@keyframes cuIcon-spin14 {
		0% {
			-webkit-transform: rotate(-45deg);
			transform: rotate(-45deg);
			top: 0.875rem;
		}
		
		20% {
			-webkit-transform: rotate(0deg);
			transform: rotate(0deg);
			top: 1.35rem;
		}
		
		100% {
			-webkit-transform: rotate(0deg);
			transform: rotate(0deg);
		}
	}
	* {
		padding: 0;
		margin: 0;
	}
	
	.navigation {
		max-width: 33.75rem;
		margin: 0 auto;
	}

	.navig {
		max-width: 33.75rem;
		margin: 0 auto;
		height: 3.25rem;
		margin: 0 auto;
		z-index: 999;
		background-color: white;
		display: flex;
		justify-content: space-between;
		position: relative;
	}

	.navig .image {
		/* width: 50%; */
		position: relative;
		left:5%;
		top: -30%;
		/* float: left; */
		font-size: 5rem;
		color: #00C785;
		/* border: #2C3E50 1px solid; */
	}

	.navig img {
		position: absolute;
		left: 5%;
		top: 15%;
		width: 3rem;
		height: 3rem;
	}

	.navig .button {
		/* float: left; */
		position:relative;
		left: -0.01%;
		top: 10%;
		/* bottom: -10.0625rem; */
		height: 50px;
		width: 50px;
	}

	.navig .button .line1 {
		width: 1.25rem;
		height: 0.12rem;
		background: rgba(8, 1, 2, 1);
		/* background-color: red; */
		border-radius: 0.1875rem;
		position: absolute;
		top: 28px;
		left: 15px;
		/* margin-top: 20px; */
		z-index: 999;
	}

	.navig .button .line2 {
		width: 1.25rem;
		height: 0.12rem;
		background: rgba(8, 1, 2, 1);
		border-radius: 0.1875rem;
		/* margin-top: 0.5rem; */
		position: absolute;
		top: 10px;
		left: 15px;
		/* margin-top: 20px; */
		z-index: 999;
	}
</style>

<style>
	@font-face {
	  font-family: 'iconfont';  /* project id 1631181 */
	  src: url('//at.alicdn.com/t/font_1631181_hmaf9or4mwi.eot');
	  src: url('//at.alicdn.com/t/font_1631181_hmaf9or4mwi.eot?#iefix') format('embedded-opentype'),
	  url('//at.alicdn.com/t/font_1631181_hmaf9or4mwi.woff2') format('woff2'),
	  url('//at.alicdn.com/t/font_1631181_hmaf9or4mwi.woff') format('woff'),
	  url('//at.alicdn.com/t/font_1631181_hmaf9or4mwi.ttf') format('truetype'),
	  url('//at.alicdn.com/t/font_1631181_hmaf9or4mwi.svg#iconfont') format('svg');
	}

	.iconfont {
		font-family: 'iconfont';
	}

	.navbox {
		width: 100%;
		max-width: 33.75rem;
		margin: 0  auto;
		height: 80rem;
		background-color: black;
		position: absolute;
		top:3.25rem;
		z-index: 888;
	}

	.navbox input {
		width: 22.6875rem;
		height: 2rem;
		background: rgba(29, 29, 31, 1);
		border-radius: 0.6rem;
		margin-top: 7.2%;
		text-align: center;
	}

	.navbox .icon {
		width: 1.875rem;
		position: absolute;
		left: 17%;
		top: 2.8%
	}

	.navbox .list {
		width: 90%;
		height: 3.25rem;
		border-top: 0.0625rem solid #3E3E3E;
		border-bottom: 0.0625rem solid #3E3E3E;
		line-height: 3.25rem;
		text-align: left;
		margin: 0 auto;
		font-size: 0.65rem;
		font-family: Alibaba PuHuiTi;
		font-weight: 300;
		color: rgba(255, 255, 255, 1);
		letter-spacing: 0.03125rem;
		padding-left: 1rem;
		margin-top: -1px;
	}
</style>
